import { ApiLoadingStatus } from "enum/api-loading-status.enum";
import { IImportItemsPromptSlice } from "./importItemsPromptSlice.interface";

export const ImportItemsPromptSliceInitialState: IImportItemsPromptSlice = {
  salesAccountUUID: null,
  prompt: null,
  loadingStatus: ApiLoadingStatus.IDLE,
};
